<template>
  <div class="auth-process-container">
    <div class="auth-process">
      <q-card bordered flat class="auth-process-card">
        <div class="auth-title">Reset Password</div>
        <q-form @submit="onSubmit" class="q-gutter-y-md">
          <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
            <span class="label-input mb-5">Password *</span>
            <q-input
                type="password"
                outlined
                hide-bottom-space
                color="grey-7"
                v-model="password"
                lazy-rules
                ref="password"
                :rules="[passwordValidation]"
                placeholder="Type your new password"
            >
              <template v-slot:prepend>
                <q-icon size="16px" color="grey-7" name="fas fa-lock"></q-icon>
              </template>
            </q-input>
          </div>
          <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
            <span class="label-input mb-5">Password (Confirmation) *</span>
            <q-input
                type="password"
                outlined
                hide-bottom-space
                color="grey-7"
                v-model="password_confirmation"
                lazy-rules
                ref="password_confirmation"
                :rules="[isValidPassword]"
                placeholder="Type your new password (confirmation)"
            >
              <template v-slot:prepend>
                <q-icon size="16px" color="grey-7" name="fas fa-lock"></q-icon>
              </template>
            </q-input>
          </div>
          <div class="flex-center">
            <q-btn id="reset-password-btn" color="positive" type="submit" :loading="loading" label="Change Password">
              <template v-slot:loading>
                <q-spinner-facebook/>
              </template>
            </q-btn>
          </div>
          <div id="reset-password-redirect" class="flex-center-item" @click="$router.push({ name: 'login' })">
            Return to Home
          </div>
        </q-form>
      </q-card>
    </div>
  </div>
</template>

<script>
import axios from '../axios/index'
import passwordValidation from "@/helper/passwordValidation";

export default {
  metaInfo() {
    return {
      title: 'Reset Password | FMS',
      meta: [
        {
          name: 'description',
          content: ''
        },
        {
          property: 'og:title',
          content: 'Reset Password | FMS'
        },
        {property: 'og:site_name', content: 'FMS'},
        {property: 'og:type', content: 'website'},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  },
  name: 'forgotPassword',
  data() {
    return {
      loading: false,
      token: '',
      password: '',
      password_confirmation: ''
    }
  },
  methods: {
    passwordValidation,
    async onSubmit() {
      if (this.password !== this.password_confirmation) {
        this.$q.notify({
          message: `Passwords do not match!`,
          timeout: 1000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
        return
      }

      try {
        this.loading = true
        const {data} = await axios.post('auth/reset-password', {
          token: this.$route.params.token,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        this.$q.notify({
          message: 'Your password has been updated.',
          timeout: 2000,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        setTimeout(() => {
          this.$router.push({name: 'login'})
        }, 1500)
      } catch (error) {
        const message = error.response.data.message
        this.$q.notify({
          message,
          timeout: 1000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
        this.token = ''
        this.password = ''
        this.password_confirmation = ''
        this.$refs.password.resetValidation()
      }
    }
  }
}
</script>
